import { useContext } from "react";

import { GeneralSearchContext } from "../contexts";

export function useGeneralSearch() {
  return useContext(GeneralSearchContext);
}
